// Satu tempat untuk menentukan alamat foto produk, dipakai di semua layar.
// Alasan dipisah: dulu aturan ini ditulis ulang di tiap halaman, lalu berbeda-beda.
import { ASAL_API as ASAL } from './api';

const DRIVE_POLA = [
  /\/file\/d\/([A-Za-z0-9_-]{10,})/,
  /[?&]id=([A-Za-z0-9_-]{10,})/,
  /\/d\/([A-Za-z0-9_-]{10,})/,
];

// Link berbagi Google Drive adalah halaman web, bukan berkas gambar.
export const rapikanFotoUrl = (u) => {
  let s = (u || '').trim();
  if (!s) return '';
  const low = s.toLowerCase();
  if (low.includes('drive.google.com') || low.includes('docs.google.com')) {
    for (const pola of DRIVE_POLA) {
      const m = s.match(pola);
      if (m) return `https://lh3.googleusercontent.com/d/${m[1]}`;
    }
  }
  return s;
};

// Untuk gambar contoh dari layanan foto stok, minta versi kecilnya sekalian
// supaya daftar pilihan produk tidak mengunduh foto ukuran penuh.
const kecilkanUrlStok = (u, lebar) => {
  try {
    const url = new URL(u);
    const h = url.hostname;
    if (h.endsWith('images.unsplash.com') || h.endsWith('images.pexels.com')) {
      url.searchParams.set('w', String(lebar));
      url.searchParams.set('q', '70');
      return url.toString();
    }
  } catch {
    /* bukan alamat yang bisa dibaca - pakai apa adanya */
  }
  return u;
};

/**
 * Alamat foto produk.
 * @param p produk (butuh id, has_photo, photo, photo_updated)
 * @param kecil true = foto mini untuk daftar pilihan
 * Mengembalikan '' kalau produk memang belum punya foto — pemanggil
 * menampilkan kotak kosong dan TIDAK meminta apa pun ke jaringan.
 */
export const fotoProduk = (p, kecil = false) => {
  if (!p) return '';
  if (p.has_photo && p.id) {
    const v = encodeURIComponent(p.photo_updated || '');
    return `${ASAL}/api/products/${p.id}/photo${kecil ? '?ukuran=kecil&v=' : '?v='}${v}`;
  }
  const link = rapikanFotoUrl(p.photo);
  if (!link) return '';
  return kecil ? kecilkanUrlStok(link, 200) : link;
};
